// بيانات الموقع - قابلة للتعديل
export const siteData = {
  // معلومات الموقع الأساسية
  siteName: "moda-lady",
  whatsappNumber: "2130657362317",
  facebookUrl: "#",
  address: "الجزائر",

  // رسالة واتساب الافتراضية
  defaultWhatsappMessage: "مرحبًا moda-lady، أريد الاستفسار عن تشكيلة الملابس النسائية.",

  // روابط التنقل
  navigationLinks: [
    { name: "الرئيسية", href: "#home" },
    { name: "المنتجات", href: "#products" },
    { name: "العروض", href: "#offers" },
    { name: "الأسئلة", href: "#faq" },
    { name: "اتصل بنا", href: "#contact" }
  ],

  // النص التسويقي الرئيسي
  heroContent: {
    title: "moda-lady - أناقتك تبدأ من هنا",
    ctaText: "تسوقي الآن عبر واتساب",
    mainImage: "/img/NanoBanana-2026-01-25(1)(1).png"
  },

  // المميزات
  features: [
    {
      icon: '👗',
      title: 'أحدث الصيحات',
      description: 'تشكيلة متجددة من أرقى الملابس'
    },
    {
      icon: '✨',
      title: 'جودة عالية',
      description: 'أقمشة مختارة بعناية لراحتك'
    },
    {
      icon: '💰',
      title: 'أسعار تنافسية',
      description: 'أفضل قيمة مقابل السعر'
    },
    {
      icon: '🚚',
      title: 'توصيل سريع',
      description: 'خدمة توصيل لجميع الولايات'
    }
  ],

  // صور المنتج
  productImages: [
    '/img/photo_2026-01-25_07-07-54.jpg',
    '/img/photo_2026-01-25_07-07-59.jpg',
    '/img/photo_2026-01-25_07-08-02.jpg',
    '/img/photo_2026-01-25_07-08-06.jpg',
    '/img/photo_2026-01-25_07-08-12.jpg',
    '/img/photo_2026-01-25_07-08-20.jpg',
    '/img/photo_2026-01-25_07-08-24.jpg',
    '/img/photo_2026-01-25_07-08-27.jpg'
  ],

  // بيانات معرض الأعمال
  worksShowcase: [
    {
      image: '/img/photo_2026-01-25_07-08-33.jpg',
      title: 'أناقة يومية'
    },
    {
      image: '/img/photo_2026-01-25_07-08-36.jpg',
      title: 'إطلالة مميزة'
    },
    {
      image: '/img/photo_2026-01-25_07-08-39.jpg',
      title: 'رقي وبساطة'
    },
    {
      image: '/img/photo_2026-01-25_07-07-54.jpg',
      title: 'جودة تدوم'
    },
    {
      image: '/img/photo_2026-01-25_07-07-59.jpg',
      title: 'تصاميم عصرية'
    },
    {
      image: '/img/photo_2026-01-25_07-08-02.jpg',
      title: 'راحة وأناقة'
    }
  ],

  // آراء العملاء
  testimonials: [
    {
      name: 'سارة ب.',
      text: 'الملابس رائعة جداً والجودة ممتازة، شكراً moda-lady!',
      image: 'https://via.placeholder.com/60x60/C85C5C/FFFFFF?text=S'
    },
    {
      name: 'ليلى م.',
      text: 'توصيل سريع وتعامل راقي، أنصح الجميع بالتعامل معهم.',
      image: 'https://via.placeholder.com/60x60/E56B6F/FFFFFF?text=L'
    },
    {
      name: 'مريم ع.',
      text: 'أجمل ملابس نسائية وجدتها، الأسعار مناسبة جداً.',
      image: 'https://via.placeholder.com/60x60/F4E3D7/2F3E46?text=M'
    },
    {
      name: 'ياسمين هـ.',
      text: 'التشكيلة متنوعة وتناسب كل الأذواق.',
      image: 'https://via.placeholder.com/60x60/E56B6F/FFFFFF?text=Y'
    }
  ],

  // الألوان المستخدمة في الموقع
  colors: {
    primary: '#C85C5C',
    secondary: '#E56B6F',
    background: '#FFF9F9',
    accent: '#F4E3D7',
    text: '#2F3E46',
    gold: '#FFD700'
  }
};

// دالة لإنشاء رابط واتساب
export const createWhatsappUrl = (number, message) => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${number}?text=${encodedMessage}`;
};

// دالة للحصول على رابط واتساب الافتراضي
export const getDefaultWhatsappUrl = () => {
  return createWhatsappUrl(siteData.whatsappNumber, siteData.defaultWhatsappMessage);
};
